// extracted by css-extract-rspack-plugin
export default {"itemTileWrapper":"_770684ab"};